// Imports
import { PageBreadcrumb } from './_page-breadcrumb.jsx';
import { Noticeboard } from '../../noticeboard/jsx/noticeboard.jsx';



// Stateless components

export function NoticeboardPage(props) {

    //
    // Render
    //

    return (
        <>
            <div id="main__content" className="main__column">
                <PageBreadcrumb
                    title="Noticeboard"
                    link="#/"
                    linkText="Back to myGriffith Home"
                />
                <Noticeboard type="full" />
            </div>
        </>
    );

};
